import styled from 'styled-components';

export const IframeStyled = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;

export const DivStyled = styled.div`
  background-color: transparent;
`;
